import { createBlock as a, openBlock as r, withCtx as t, createVNode as o, unref as s, renderSlot as n } from "vue";
import { themeProp as l } from "../../../composables/useTheme.js";
import { screenProp as m } from "../../../utils/utilsScreen.js";
import d from "../utils/card-props.vue.js";
import g from "./card.vue.js";
import h from "../../../utils/validators/image.js";
import w from "../../../atoms/image-element/image-element.vue.js";
const p = "DsCardWithImageComponent", j = /* @__PURE__ */ Object.assign({
  name: p
}, {
  __name: "card-with-image",
  props: {
    ...d,
    ...l,
    ...m,
    image: {
      type: Object,
      required: !0,
      validator: h
    }
  },
  setup(i) {
    return (e, u) => (r(), a(g, {
      class: "card-with-image",
      "aspect-ratio": e.aspectRatio,
      eyebrow: e.eyebrow,
      icon: e.icon,
      tags: e.tags,
      "tag-color": e.tagColor,
      title: e.title,
      text: e.text,
      subtitle: e.subtitle,
      subtext: e.subtext,
      link: e.link,
      "with-title-size-large": e.withTitleSizeLarge,
      "with-title-size-small": e.withTitleSizeSmall,
      "with-subtitle-size-large": e.withSubtitleSizeLarge,
      "with-shadow": e.withShadow,
      contained: e.contained,
      "with-padding-large": e.withPaddingLarge,
      "center-aligned": e.centerAligned,
      "with-text-size-medium": e.withTextSizeMedium,
      theme: e.theme,
      "data-j-card": ""
    }, {
      text: t(() => [
        n(e.$slots, "default")
      ]),
      media: t(() => [
        o(s(w), {
          image: i.image,
          "aspect-ratio": e.aspectRatio,
          "with-padding": e.withPaddingLarge,
          screen: e.screen,
          "data-j-image": ""
        }, null, 8, ["image", "aspect-ratio", "with-padding", "screen"])
      ]),
      _: 3
    }, 8, ["aspect-ratio", "eyebrow", "icon", "tags", "tag-color", "title", "text", "subtitle", "subtext", "link", "with-title-size-large", "with-title-size-small", "with-subtitle-size-large", "with-shadow", "contained", "with-padding-large", "center-aligned", "with-text-size-medium", "theme"]));
  }
});
export {
  j as default
};
